import { Subtask } from 'constants/interfaces'
import { isMediaAnswer } from './execution'
import type { ITaskOverviewContentStack } from '../TaskOverviewStackProvider'

/** Preserve the overview frame and its local drafts while media owns the full work area. */
export function navigateExecutionStack(
  stack: ITaskOverviewContentStack[],
  subtask: Subtask
): ITaskOverviewContentStack[] {
  const top = stack[stack.length - 1]
  if (!top || !['MAIN', 'MEDIA_SUBTASK_COMPLETING'].includes(top.contentType)) return stack
  const mainIndex = stack.findIndex((frame) => frame.contentType === 'MAIN')
  const next = stack.slice()
  if (mainIndex >= 0)
    next[mainIndex] = { ...next[mainIndex], props: { ...next[mainIndex].props, selectedSubtaskId: subtask.st_id } }
  if (!isMediaAnswer(subtask)) return mainIndex >= 0 ? next.slice(0, mainIndex + 1) : stack
  const media = {
    contentType: 'MEDIA_SUBTASK_COMPLETING' as ITaskOverviewContentStack['contentType'],
    props: { selectedSubtask: subtask },
  }
  if (top.contentType === 'MEDIA_SUBTASK_COMPLETING') next[next.length - 1] = media
  else next.push(media)
  return next
}
